var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('make-banner',{attrs:{"height":"320","id":1}}),_c('recomend-list'),_c('module-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }